'use strict';

/**
 * iOS Modal Fix
 * Scrolls to proper place in window after
 * setting body to fixed position
 */
module.exports = function () {
    var $window = $(window);
    var $body = $('body');
    var $modal = $('.modal');
    var scrollDistance = 0;

    $modal.on('show.bs.modal', function() {
        scrollDistance = $window.scrollTop();
        $body.css('top', scrollDistance * -1);
    });

    $modal.on('hidden.bs.modal', function() {
        $body.css('top', '');
        $window.scrollTop(scrollDistance);  
    });
}